import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { SnackbarAlertWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allPagosSuscripcionAction,
  setActivoPagosSuscripcionAction,
} from './PagosSuscripcionAction';
import ListadoPagosSuscripcion from './components/ListadoPagosSuscripcion';

const PagosSuscripcionView = () => {
  const dispatch = Redux.useDispatch();

  const suscripcionesStore = Redux.useSelector((state) => state.suscripciones);
  const pagosSuscripcionStore = Redux.useSelector(
    (state) => state.pagosSuscripcion,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={pagosSuscripcionStore.alertView} />
      <Grid item md={12}>
        {/* <BotonComponent
          click={async () => {
            await setActivoPagosSuscripcionAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        /> */}
        {pagosSuscripcionStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              await setActivoPagosSuscripcionAction(dispatch, null);
              await allPagosSuscripcionAction(
                dispatch,
                pagosSuscripcionStore.params,
              );
            }}
            disabled={pagosSuscripcionStore.loadingAll}
            white
            refreshIcon
            text={
              pagosSuscripcionStore.loadingAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        ) : null}
      </Grid>
      <Grid item md={12}>
        <ListadoPagosSuscripcion
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      {/* <ModalComponent
        id="modalFormPagosSuscripcion"
        title={
          pagosSuscripcionStore.activo
            ? `Editar ${pagosSuscripcionStore.activo.nombre}`
            : "Nueva carrera"
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormPagosSuscripcion
          activo={pagosSuscripcionStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent> */}
    </Grid>
  );
};

export default PagosSuscripcionView;
